import { NativeModules, Platform } from 'react-native';
import { getPageProps } from '@kibt/krn-utils';
import queryString from 'query-string';

// https://kds.corp.kuaishou.com/kds-react/detail?detailId=162&showSideNav=1&menuId=22
export function getBundleInfo(): {
    bundleId: string;
    componentName: string;
    version?: string;
    versionCode?: number;
} {
    if (Platform.OS !== 'web') {
        const { rootTag } = getPageProps();
        const bundleInfo = NativeModules.KRNBasic.getBundleInfo(rootTag);
        return bundleInfo;
    } else {
        const parseUrl = queryString.parseUrl(window.location.href);
        const redirectUrl = parseUrl.query.redirectUrl;
        try {
            const parseRedirect = queryString.parse(redirectUrl as string);
            return { bundleId: parseRedirect.bundleId as string, componentName: parseRedirect.componentName as string };
        } catch (e) {
            console.error(e);
        }
        return {} as any;
    }
}
